import _ from 'lodash';
import React from 'react';
import {connect} from 'react-redux';
import {reduxForm, Field} from 'redux-form';

import Label from 'components/Label';
import EdditableFormField from 'components/EdditableFormField';
import ErrorBlock from 'components/ErrorBlock';
import {
  TextField,
  EmailField,
  DateField,
  SearchCountryField,
  GenderField,
  NumberField,
  CheckBoxField
} from 'components/Fields';
import {getGenderFieldValue} from 'components/Fields/Gender';

import {
  updateUser,
  fetchUser,
  MODALS,
  getUserBirthday,
  getUserNationality,
  fetchUsers
} from 'ducks/users';
import {selectCountries} from 'ducks/countries';
import {storeDataInModal} from 'ducks/modals';

import {validBirthDate} from 'utils/validators';
import {formatDateForApi} from 'utils/datetime';

const onSubmit = (values, dispatch, props) => {
  const {user} = props;
  const {
    fullName,
    email,
    knownAs,
    phone,
    age,
    gender,
    birthday,
    nationality,
    newJoiner,
    bio
  } = values;

  const data = {
    fullName,
    knownAs,
    phone,
    age,
    gender: getGenderFieldValue(gender),
    birthday: formatDateForApi(birthday),
    nationality: _.get(nationality, 'value'),
    newJoiner,
    bio,
    userId: user.id
  };

  if (!user.isAdmin) {
    data['email'] = email;
  }

  const fetchUserExtraActions = [
    ...props.storeDataExtraActions(data => ({
      user: data
    }))
  ];

  const extraActions = [
    () =>
      storeDataInModal({
        modalName: MODALS.USER_DETAIL,
        data: {isInEditMode: false}
      }),
    () => fetchUser({userId: user.id}, fetchUserExtraActions),
    () => fetchUsers()
  ];

  dispatch(updateUser(data, extraActions));
};

const UserEditForm = ({error, isInEditMode, countries, user}) => {
  const emptyPlaceholder = isInEditMode ? null : '';

  return (
    <form className="UserEditForm">
      {error && <ErrorBlock>{error}</ErrorBlock>}
      <EdditableFormField>
        <Label>full name</Label>
        <Field name="fullName" component={TextField} disabled={!isInEditMode} />
      </EdditableFormField>

      <EdditableFormField>
        <Label>email</Label>
        <Field
          name="email"
          component={EmailField}
          disabled={user.isAdmin || !isInEditMode}
        />
      </EdditableFormField>

      <EdditableFormField>
        <Label>known as</Label>
        <Field name="knownAs" component={TextField} disabled={!isInEditMode} />
      </EdditableFormField>

      <EdditableFormField>
        <Label>phone</Label>
        <Field name="phone" component={TextField} disabled={!isInEditMode} />
      </EdditableFormField>

      <EdditableFormField>
        <Label>age</Label>
        <Field name="age" component={NumberField} disabled={!isInEditMode} />
      </EdditableFormField>

      <EdditableFormField>
        <Label>date of birth</Label>
        <Field
          name="birthday"
          validate={[validBirthDate]}
          component={DateField}
          disabled={!isInEditMode}
          placeholder={emptyPlaceholder}
        />
      </EdditableFormField>

      <EdditableFormField>
        <Label className="gender">gender</Label>
        <Field name="gender" component={GenderField} disabled={!isInEditMode} />
      </EdditableFormField>

      <EdditableFormField>
        <Label className="nationality">nationality</Label>
        <SearchCountryField
          disabled={!isInEditMode}
          countries={countries}
          placeholder={emptyPlaceholder}
          name="nationality"
        />
      </EdditableFormField>

      <EdditableFormField>
        <Label>new joiner</Label>
        <Field
          name="newJoiner"
          component={CheckBoxField}
          disabled={!isInEditMode}
        />
      </EdditableFormField>

      <EdditableFormField>
        <Label>bio</Label>
        <Field name="bio" component={TextField} disabled={!isInEditMode} />
      </EdditableFormField>
    </form>
  );
};

const mapStateToProps = (state, props) => {
  const countries = selectCountries(state);
  const {user} = props;

  return {
    initialValues: {
      fullName: user.fullName,
      email: user.email,
      knownAs: user.knownAs,
      phone: user.phone,
      age: user.age,
      birthday: getUserBirthday(user),
      gender: user.gender,
      nationality: getUserNationality(user),
      newJoiner: user.newJoiner,
      bio: user.bio
    },
    userId: user.id,
    countries
  };
};

export default connect(mapStateToProps)(
  reduxForm({
    form: 'updateUser',
    onSubmit
  })(UserEditForm)
);
